import Component from 'components/pages/PrivacyNotice/PrivacyNotice.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('privacy-notice', {
  withoutHeaderOnMobile: true,
  withoutFooterOnMobile: true,
});
export default buildPage(Component, {
  requiresAuthentication: false,
  metaData: {
    title: 'Privacy Notice',
    description:
      'Qmee privacy notice which governs the collection, storage and use of personal data collected by us.',
  },
});
